import { Dispositif } from '../shared/Dispositif'
import { Entites } from '../shared/Entite'

export const TypePermission = [...Dispositif, ...Entites] as const

export type TypePermission = (typeof TypePermission)[number]

export const TypePermissionLibelle: Record<TypePermission, string> = {
  CPRO: 'CPRO',
  CAPP: 'CAPP',
  PROA: 'PROA',
  AF: 'AF',
  Facture: 'Facture',
  RIB: 'RIB',
  Administration: 'Administration',
  Virement: 'Virement',
} as const
